// extracted by mini-css-extract-plugin
export var resizer = "_dz-0";